import { useState } from "react";
import PaginationComponent from "../../../components/PaginationComponent";
import { sortArray } from "../../../utils/Functions/filter";
import FaqListItem from "../components/FaqListItem";

export default function Questions({
  faqList = [],
  access = {},
  loading,
  refresh = {},
}) {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const pageCount = Math.ceil(faqList.length / pageSize);
  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
  };
  return (
    <>
      <div className="table-responsive ">
        <table className="table table-borderless">
          <thead>
            <tr className=" ">
              {access.isAdmin && <td className=""></td>}
              <td className="col-sm-2">Category Name</td>
              <td className={access.canEdit ? "col-sm-6" : "col-sm-8"}>
                Question{" "}
              </td>
              <td className={access.canEdit ? "col-sm-6" : "col-sm-8"}>
                answer
              </td>
              <td className="col-sm-2">Status</td>
              {access.canEdit && <td className="col-sm-2">Action</td>}
            </tr>
          </thead>
          <tbody>
            {!loading && faqList && faqList.length > 0 ? (
              sortArray(faqList)
                .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
                .map((x, i) => (
                  <FaqListItem
                    key={i}
                    item={x}
                    index={i}
                    refresh={refresh}
                    access={access}
                  />
                ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  <span className="font-weight-bold">
                    {loading ? "Loading..." : "Oops! No Data Found"}
                  </span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {faqList.length > 0 && pageCount != 1 && (
        <PaginationComponent
          handleClick={handleClick}
          currentPage={currentPage}
          pageCount={pageCount}
        />
      )}
    </>
  );
}